import CLIDownload from "../../../../contents/docs/error-tracking/_snippets/cli/download.mdx";
import CLIAuthenticate from "../../../../contents/docs/error-tracking/_snippets/cli/authenticate.mdx";
import InjectSourceMap from "../../../../contents/docs/error-tracking/upload-source-maps/_snippets/inject-source-map.mdx";
import UploadSourceMap from "../../../../contents/docs/error-tracking/upload-source-maps/_snippets/upload-source-map.mdx";
import StepVerifySourceMapUpload from "../../../../contents/docs/error-tracking/upload-source-maps/_snippets/step-verify-source-map-upload.mdx";
import * as React from 'react';
export default {
  CLIDownload,
  CLIAuthenticate,
  InjectSourceMap,
  UploadSourceMap,
  StepVerifySourceMapUpload,
  React
};